<template>
  <SettingsBox title="Widok" description="Ukryj lub wyświetl dodatkowe elementy na jadłospisie.">
    <div class="diet-nutrients-section">
      <div class="diet-nutrients-section__header">
        <div class="diet-nutrients-section__title">
          <Text as="h3" size="text-sm" weight="semibold">
            Najważniejsze składniki odżywcze ({{ visibleChosen.length }}/5)
          </Text>
          <Tooltip placement="top">
            <template #trigger><Icon name="HelpCircle" :size="16" /></template>
            Wybierz maksymalnie 5 składników widocznych przy posiłkach oraz w grafiku.
          </Tooltip>
        </div>
      </div>
      <Flex :gap="12" align-y="center">
        <div class="diet-nutrients-section__selected">
          <Text
            v-if="visibleChosen.length === 0"
            as="p"
            color="color-text-text-tertiary-600"
            size="text-sm"
          >
            Nie wybrano jeszcze żadnych parametrów.
          </Text>
          <Badge v-for="nutrient in visibleChosen" :key="nutrient" color="brand" size="sm">
            {{ nutrientsMap[nutrient].name }}
          </Badge>
        </div>

        <Button color="gray" @click="emit('edit')">
          <template #leftIcon><Icon name="Edit05" /></template>
          Edytuj
        </Button>
      </Flex>
      <Text as="p" color="color-text-text-tertiary-600" size="text-sm">
        Wybierz maksymalnie 5 kluczowych składników dla tego jadłospisu.
      </Text>
    </div>
  </SettingsBox>
</template>

<script lang="ts" setup>
  import { computed } from 'vue'

  import { Badge, Button, Flex, Icon, Text, Tooltip } from '@/components/ui'
  import { nutrientsMap } from '@/utils/nutrients'

  import type { Nutrients } from '@/utils/nutrients'

  import { SettingsBox } from '../SettingsBox'

  import { hiddenNutrients } from './constants'

  const props = defineProps<{ chosen: Nutrients[] }>()
  const emit = defineEmits<{ edit: [] }>()
  const visibleChosen = computed(() =>
    props.chosen.filter(nutrient => !hiddenNutrients.includes(nutrient)),
  )
</script>

<style lang="scss" scoped>
  .diet-nutrients-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .diet-nutrients-section__header,
  .diet-nutrients-section__title,
  .diet-nutrients-section__selected {
    display: flex;
    align-items: center;
  }

  .diet-nutrients-section__header {
    gap: 16px;
    justify-content: space-between;
  }

  .diet-nutrients-section__title {
    gap: 4px;
  }

  .diet-nutrients-section__title :deep(.ui-icon) {
    color: var(--color-foreground-fg-quaternary-500);
  }

  .diet-nutrients-section__selected {
    flex-wrap: wrap;
    gap: 8px;
    min-height: 48px;
    padding: 8px 12px;
    background: var(--color-background-bg-primary);
    border: 1px solid var(--color-border-border-secondary);
    border-radius: var(--radius-md);
  }

  @media (width <= 600px) {
    .diet-nutrients-section__header {
      align-items: flex-start;
      flex-direction: column;
    }
  }
</style>
